function NewClient({ style }) {
  const { fill = '#FF9838', width = 16, height = 16 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M8.067 0a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-.752 5.943c.64.1 1.302-.542 1.479-1.435.176-.893-.2-1.698-.84-1.799-.64-.1-1.302.542-1.478 1.435-.177.893.2 1.698.84 1.799ZM9.766 7.06c.578.287 1.367-.147 1.763-.97.395-.824.247-1.724-.331-2.011-.578-.288-1.367.147-1.762.97-.396.823-.248 1.724.33 2.011ZM12.6 9.07c-.351.731-1.071 1.108-1.608.842-.536-.267-.686-1.077-.335-1.808.351-.732 1.071-1.11 1.608-.842.537.266.687 1.076.335 1.808ZM4.575 7.075c.576.056 1.138-.548 1.255-1.348.118-.8-.254-1.495-.83-1.55-.576-.057-1.138.547-1.255 1.347-.117.8.254 1.495.83 1.55Zm5.309 3.71c-.242 1.49-.863 2.212-1.652 2.307-.308.037-.656-.3-1.024-.659-.3-.292-.615-.598-.935-.727-.32-.13-.758-.127-1.176-.126-.514.002-.998.004-1.197-.238-.503-.614-.446-1.568.414-2.806.86-1.239 2.349-2.224 3.887-1.602 1.538.621 1.924 2.363 1.683 3.852Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default NewClient;
